import {Project} from '../model/Project';
import {v4 as uuidv4} from 'uuid';
export const makiMakiApp: Project = {
  id: uuidv4(),
  label: 'Maki-Maki',
  description: 'More info coming soon...',
};
